import { useEffect } from 'react';
import { shouldRedirect, getRedirectUrl } from '../utils/domains';

export function DomainRedirect() {
  useEffect(() => {
    if (shouldRedirect()) {
      const redirectUrl = getRedirectUrl();
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
  }, []);

  return null;
}